import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface WorkflowStep {
  label: string;
  disabled?: boolean;
  stepId?: any; // Optional identifier for the step
}

@Component({
    selector: 'app-workflow-steps',
    templateUrl: './workflow-steps.component.html',
    styleUrls: ['./workflow-steps.component.scss'],
    standalone: false
})
export class WorkflowStepsComponent {

  @Input() steps: WorkflowStep[] = [];
  @Input() activeIndex: number = 0;
  @Input() completedSteps: number[] = [];
  @Input() clickable: boolean = false;

  @Output() stepChange = new EventEmitter<number>();

  isCompleted(index: number): boolean {
    return this.completedSteps.includes(index);
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  onStepClick(index: number) {
    if (!this.clickable) return;
    if (this.steps[index]?.disabled) return;

    this.stepChange.emit(index);
  }
}
